import { Oval } from 'react-loader-spinner';

/** Shared spinner. Brand orange — the old #734792 purple was off-brand. */
export const Spinner = ({ size = 48 }) => (
  <Oval
    height={size}
    width={size}
    color='#F49038'
    secondaryColor='#FDE9D8'
    strokeWidth={3}
    strokeWidthSecondary={3}
    visible
    ariaLabel='loading'
    wrapperStyle={{}}
    wrapperClass=''
  />
);

/** Full-viewport blocking loader, for route transitions and the auth gate. */
const PageLoader = () => (
  <div className='fixed inset-0 z-[55] flex items-center justify-center bg-surface/80'>
    <Spinner size={56} />
  </div>
);

export default PageLoader;

/**
 * In-flow loader for a single component. It used to be `absolute` while still
 * sized `w-screen h-screen`, so it covered the viewport rather than its own
 * component.
 */
export const ComponentLoader = () => (
  <div className='flex w-full items-center justify-center py-16'>
    <Spinner />
  </div>
);
